import React, { useEffect, useState } from 'react';
import { confirmPasswordReset } from 'firebase/auth';
import { auth } from './firebase';

function RecuperarSenha() {
  const [novaSenha, setNovaSenha] = useState('');
  const [oobCode, setOobCode] = useState(null);
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);

  useEffect(() => {
    document.title = 'PromoAlert | Redefinir senha';

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('oobCode');

    if (code) {
      setOobCode(code);
    } else {
      setErro('Link inválido ou expirado. Solicite uma nova redefinição de senha.');
    }
  }, []);

  const validadorSenhaForte = (senha) => {
    if (senha.length < 6) return false;
    if (!senha.match(/[a-zA-Z]/)) return false;
    if (!senha.match(/[0-9]/)) return false;
    if (!senha.match(/[!@#$%^&*(),.?":{}|<>]/)) return false;
    return true;
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setErro('');
    setMensagem('');

    if (!validadorSenhaForte(novaSenha)) {
      setErro('A nova senha deve ter no mínimo 6 caracteres, com letras, números e símbolos especiais (!@#).');
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, novaSenha);
      setSucesso(true);
      setMensagem('Senha alterada com sucesso. Você já pode fechar esta página e voltar ao aplicativo.');
    } catch (error) {
      console.error(error);
      setErro('Não foi possível concluir a redefinição. O link pode ter expirado. Solicite um novo e-mail.');
    }
  };

  const paginaStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(180deg, #f3f7fb 0%, #ffffff 100%)',
    padding: '24px',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  };

  const cardStyle = {
    width: '100%',
    maxWidth: '460px',
    backgroundColor: '#ffffff',
    borderRadius: '24px',
    border: '1px solid #dbe5f0',
    boxShadow: '0 24px 60px rgba(15, 23, 42, 0.08)',
    padding: '32px',
  };

  const chipStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '999px',
    backgroundColor: '#eef6ff',
    color: '#0f4c81',
    border: '1px solid #cfe3f8',
    padding: '8px 14px',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginBottom: '18px',
  };

  if (sucesso) {
    return (
      <div style={paginaStyle}>
        <div style={{ ...cardStyle, textAlign: 'center' }}>
          <div style={chipStyle}>Segurança da conta</div>
          <h1 style={{ margin: '0 0 14px', fontSize: '32px', color: '#13203b' }}>Senha atualizada</h1>
          <p style={{ margin: 0, color: '#5b6b84', lineHeight: '1.7', fontSize: '16px' }}>{mensagem}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={paginaStyle}>
      <div style={cardStyle}>
        <div style={chipStyle}>PromoAlert | VMS</div>
        <h1 style={{ margin: '0 0 12px', fontSize: '34px', lineHeight: '1.1', color: '#13203b' }}>Criar nova senha</h1>
        <p style={{ margin: '0 0 24px', color: '#5b6b84', lineHeight: '1.7', fontSize: '16px' }}>
          Defina uma nova senha para continuar acessando sua conta com segurança.
        </p>

        {erro && (
          <div
            style={{
              marginBottom: '18px',
              padding: '14px 16px',
              borderRadius: '14px',
              backgroundColor: '#fff5f5',
              border: '1px solid #fecaca',
              color: '#b91c1c',
              lineHeight: '1.6',
              fontSize: '14px',
            }}
          >
            {erro}
          </div>
        )}

        <form onSubmit={handleResetPassword} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <label style={{ color: '#1f2d4d', fontSize: '14px', fontWeight: '700' }}>Nova senha</label>
          <input
            type="password"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            required
            placeholder="Ex.: MinhaSenha!123"
            style={{
              padding: '14px 16px',
              borderRadius: '14px',
              border: '1px solid #cbd5e1',
              fontSize: '16px',
              color: '#13203b',
              outline: 'none',
            }}
          />

          <div
            style={{
              padding: '14px 16px',
              borderRadius: '14px',
              backgroundColor: '#f8fafc',
              border: '1px solid #e2e8f0',
              color: '#5b6b84',
              fontSize: '13px',
              lineHeight: '1.6',
            }}
          >
            Use pelo menos 6 caracteres com letras, números e símbolos especiais.
          </div>

          <button
            type="submit"
            disabled={!oobCode}
            style={{
              marginTop: '4px',
              padding: '14px 18px',
              background: oobCode ? 'linear-gradient(135deg, #0f4c81 0%, #0f5ca8 100%)' : '#cbd5e1',
              color: '#ffffff',
              border: 'none',
              borderRadius: '14px',
              cursor: oobCode ? 'pointer' : 'not-allowed',
              fontWeight: '700',
              fontSize: '16px',
            }}
          >
            Salvar nova senha
          </button>
        </form>
      </div>
    </div>
  );
}

export default RecuperarSenha;
